import { Typography } from "@codat/orchard-ui";
import { IconProps } from "@codat/orchard-ui/dist/es/icons/types";
import { IntegrationCountsValues } from "api/portal";
import React from "react";
import { Link } from "react-router-dom";

import Button from "components/Button";

import { getButtonAriaLabel } from "./getButtonLabel";
import styles from "./SettingsSection.module.scss";

export interface SettingsNavItemProps {
  name: string;
  icon: React.ComponentType<IconProps>;
  path?: string;
  linkText: string;
  integrationCounts?: IntegrationCountsValues;
}

const SettingsNavItem = ({
  name,
  path,
  linkText,
  icon: MenuItemIcon,
  integrationCounts,
}: SettingsNavItemProps) => {
  const content = (
    <li>
      <div className={styles.navItemNameIconWrapper}>
        <div className={styles.navItemIcon}>
          <MenuItemIcon />
        </div>
        <Typography as="h3" variant="heading_sm" className={styles.navItemName}>
          {name}
        </Typography>
      </div>

      {integrationCounts?.total ? (
        <DisplayEnabledCounts {...integrationCounts} />
      ) : null}
      {path && (
        <Button
          buttonName={name}
          to={path}
          label={linkText}
          aria-label={getButtonAriaLabel(name, linkText)}
          variant="secondary"
          color="interface"
          size="small"
          className={styles.navItemButton}
        />
      )}
    </li>
  );

  if (path) {
    return (
      <Link
        to={path}
        key={`${name}-${path}`}
        className={styles.navItem}
        data-testid="settings-nav-item"
        tabIndex={-1} // Button should be tabbable, but not the row
      >
        {content}
      </Link>
    );
  } else {
    return <div className={styles.navItem}>{content}</div>;
  }
};

const DisplayEnabledCounts = ({ enabled, total }: IntegrationCountsValues) => {
  return (
    <Typography
      data-testid="integrations-counts"
      as="p"
      variant="body_sm"
      className={styles.counts}
    >{`${enabled}/${total} enabled`}</Typography>
  );
};

export default SettingsNavItem;
